export const API_KEYS = [
    {
        placeholder: '<your-tomtom-maps-API-key>',
        name: 'api.key.maps',
        label: 'Maps API key'
    },
    {
        placeholder: '<your-tomtom-traffic-API-key>',
        name: 'api.key.traffic',
        label: 'Traffic API key'
    }, {
        placeholder: '<your-tomtom-traffic-flow-API-key>',
        name: 'api.key.trafficFlow',
        label: 'Traffic Flow API key'
    }, {
        placeholder: '<your-tomtom-search-API-key>',
        name: 'api.key.search',
        label: 'Search API key'
    }, {
        placeholder: '<your-tomtom-routing-API-key>',
        name: 'api.key.routing',
        label: 'Routing API key'
    },
    {
        placeholder: '<your-tomtom-extended-search-API-key>',
        name: 'api.key.extendedSearch',
        label: 'Extended Search API key'
    }
];

export const API_KEY_LOCALSTORAGE = 'TomTomExampleApiKeys';
